export function theading(text, colspan=0, tooltip="", id="") {
    let th = document.createElement("th");
    th.classList.add("text-center");
    if (id !== "") th.id = id;
    if (colspan > 0) th.colSpan = colspan;

    if (tooltip !== "") {
        th.setAttribute("data-bs-toggle", "tooltip");
        th.setAttribute("data-bs-placement", "top");
        th.setAttribute("data-bs-html", "true");
        th.setAttribute("title", tooltip);
        th.innerHTML = text + " <i class='fas fa-info-circle'></i>";
    } else {
        th.innerText = text;
    }

    return th;
}

export function simpleRow(text, redact=false, centered=false) {
    let td = document.createElement("td");
    if (redact) {
        td.classList.add("redactable");
    }
    if (centered) {
        td.classList.add("text-center");
    }
    td.innerText = text;
    return td;
}

export function simpleRowHtml(text) {
    let td = document.createElement("td");
    td.innerHTML = text;
    return td;
}

export function clearDiv(target, targetLength=0) {
    while (target.children.length > targetLength) {
        target.removeChild(target.lastChild);
    }
}